export default {
    name: "GridPattern",
    props: {
        topGrid: {
            type: Boolean,
            required: false,
            default: false
        },
        bottomGrid: {
            type: Boolean,
            required: false,
            default: false
        },
        colortheme: {
            type: String,
            required: false,
            default: false
        }
    },
    setup(){
 

        return {
        
        }
    }
}